<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        
        <v-row class="py-1 px-5">
          <v-col cols="12" md="4" ACCOUNTTOPINFOandSELECTOR>
            <v-row>
              <v-col cols="12" ACCOUNTSELECTOR>
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" class="text-center">
                        <v-list>
                          <v-list-item-group v-model="selectedPanel">
                            <v-list-item
                              v-for="(item, i) in subitems"
                              :key="i"
                              :value="item.value"
                            >
                              <v-list-item-icon>
                                <v-icon v-text="item.icon"></v-icon>
                              </v-list-item-icon>
                              <v-list-item-content @click="showPannel(item.value)" :class="`${arabic?'arFont':'enFont'}`">
                                <v-list-item-title >{{ i18n[item.text] }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="8">
            <v-row>
              <v-col cols="12" PANNELS>
                <v-card v-if="firstPanel" :loading="loading" SUPPORTPanel>
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">support_agent</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">
                              {{ i18n['submit_a_complaint'] }}
                            </div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">
                              {{ i18n['you_submit_all_your_complaint_details_to_get_help'] }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="6" FIELD>
                            <v-text-field
                              :label="i18n['email']"
                              v-model="user.email"
                              :class="`${arabic?'arFont':'enFont'}`"
                              disabled
                              readonly
                              outlined
                              hide-details
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" FIELD>
                            <v-text-field
                              :label="i18n['subject_or_order_id']"
                              v-model="ticket.subject"
                              :class="`${arabic?'arFont':'enFont'}`"
                              outlined
                              hide-details
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" FIELD>
                            <v-textarea
                              :label="i18n['complaint_details']"
                              v-model="ticket.ticket"
                              :class="`${arabic?'arFont':'enFont'}`"
                              outlined
                              hide-details
                              dense
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" :class="`${arabic?'arFont':'enFont'}`" @click="sendTicket('complain')">{{ i18n['send'] }}</v-btn>
                  </v-card-actions>
                </v-card>
                <v-card v-if="secondPanel" :loading="loading" SUGGESTIONPanel>
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">add_box</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">
                              {{ i18n['submit_a_suggestion'] }}
                            </div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">
                              {{ i18n['submit_suggestion_details'] }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="6" FIELD>
                            <v-text-field
                              :label="i18n['email']"
                              v-model="user.email"
                              :class="`${arabic?'arFont':'enFont'}`"
                              disabled
                              readonly
                              outlined
                              hide-details
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" FIELD>
                            <v-text-field
                              :label="i18n['subject']"
                              v-model="ticket.subject"
                              :class="`${arabic?'arFont':'enFont'}`"
                              outlined
                              hide-details
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" FIELD>
                            <v-textarea
                              :label="i18n['suggestions_details']"
                              v-model="ticket.ticket"
                              :class="`${arabic?'arFont':'enFont'}`"
                              outlined
                              hide-details
                              dense
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" :class="`${arabic?'arFont':'enFont'}`" @click="sendTicket('suggestion')">{{i18n['send']}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Search from '@/components/Search'
export default {
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      firstPanel:true,
      secondPanel:false,
      selectedPanel:'firstPanel',
      subitems:[
        {
          text:'support',
          icon:'support_agent',
          value:'firstPanel'
        },
        {
          text:'suggestions',
          icon:'add_box',
          value:'secondPanel'
        },
      ],
      text:null,
      ticket:{},
    }
  },
  methods: {
    async sendTicket(type){
      this.loading = true
      this.ticket.type = type
      let a = await this.$store.dispatch('postResource', {resource:'/tickets', value:this.ticket})
      // console.log(a)
      this.$emit('snackbarNotification', this.i18n['already_sent'], 'success')
      this.ticket = {}
      this.loading = false
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    }
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
  },
}
</script>

<style>

</style>